<template>
  <div>
    <div class="vx-row mt-4">
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <label>Tipo Conta</label>
        <v-select
          v-model="accountType"
          :options="accountTypeList"
          label="name"
          class="required-select"
        >
          <div slot="no-options">Nenhum registro encontrado!</div>
        </v-select>
        <!-- <span
          class="text-danger text-sm"
          v-show="errors.has('account_type')"
        >{{ errors.first('account_type') }}</span> -->
      </div>

      <div class="vx-col sm:w-1/2 w-full mb-2">
        <label>Instituição Bancária</label>
        <v-select
          v-model="financialInstitution"
          :options="financialInstitutionList"
          label="name"
          class="required-select"
        >
          <div slot="no-options">Nenhum registro encontrado!</div>
        </v-select>
        <!-- <span class="text-danger text-sm" v-show="errors.has('bank')">{{ errors.first('bank') }}</span> -->
      </div>
    </div>

    <div class="vx-row mt-4">
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          type="text"
          class="w-full required"
          label="Agência"
          v-model="branchNumber"
          v-validate="'required'"
        />
        <!-- <span
          class="text-danger text-sm"
          v-show="errors.has('branch_number')"
        >{{ errors.first('branch_number') }}</span> -->
      </div>

      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          type="text"
          class="w-full required"
          label="Conta"
          v-model="accountNumber"
          v-validate="'required'"
        />
        <!-- <span
          class="text-danger text-sm"
          v-show="errors.has('account_number')"
        >{{ errors.first('account_number') }}</span> -->
      </div>

      <div class="vx-col sm:w-1/4 w-full mb-2">
        <label>Data Abertura</label>
        <datepicker
          v-model="issuedAt"
          :format="format"
          :language="ptBR"
          typeable="true"
          v-mask="['##/##/####']"
        ></datepicker>
        <!-- <span
          class="text-danger text-sm"
          v-show="errors.has('issued_at')"
        >{{ errors.first('issued_at') }}</span> -->
      </div>

      <div class="vx-col sm:w-1/4 w-full mb-2">
        <b-form-checkbox v-model="head" class="mt-6 float-right">Conta principal</b-form-checkbox>
      </div>
    </div>

    <div class="vx-row mt-2">
      <div class="vx-col w-full">
        <vs-button
          v-if="this.editMode"
          class="mb-2 float-right"
          @click="cancelEdit"
          type="border"
          color="danger"
        >Calcelar</vs-button>
        <vs-button
          class="mb-2 mr-1 float-right"
          @click="save"
          type="border"
          :disabled="!validateForm"
        >{{this.editMode ? 'Alterar' : 'Adicionar'}}</vs-button>
      </div>
    </div>

    <div class="vx-row mt-4 mb-10">
      <div class="vx-col w-full">
        <vs-table :data="bankDetailList" no-data-text="Nenhum registro encontrado">
          <template slot="thead">
            <vs-th>Tipo Conta</vs-th>
            <vs-th>Instituição Bancária</vs-th>
            <vs-th>Agência</vs-th>
            <vs-th>Conta</vs-th>
            <vs-th>Data Abertura</vs-th>
            <vs-th>Principal</vs-th>
            <vs-th>Ação</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{data[indextr].account_type}}</vs-td>
              <vs-td>{{data[indextr].financial_institution.name}}</vs-td>
              <vs-td>{{data[indextr].branch_number}}</vs-td>
              <vs-td>{{data[indextr].account_number}}</vs-td>
              <vs-td>{{data[indextr].issued_at}}</vs-td>
              <vs-td>
                <span v-if="data[indextr].pivot.head">Sim</span>
                <span v-else>Não</span>
              </vs-td>
              <vs-td>
                <feather-icon
                  icon="EditIcon"
                  title="Editar"
                  style="cursor: pointer;"
                  class="h-5 w-5 mb-1 mr-3 stroke-current text-warning"
                  @click="edit(data[indextr])"
                />
                <feather-icon
                  icon="Trash2Icon"
                  style="cursor: pointer;"
                  class="h-5 w-5 mb-1 mr-3 stroke-current text-danger"
                  @click="destroy(data[indextr])"
                />
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'educatena-vuejs-datepicker'
import { ptBR } from 'educatena-vuejs-datepicker/dist/locale'
import vSelect from 'vue-select'
import Constants from '../../../../util/Constants'

import {
  BForm, BButton, BFormInput, BFormGroup, BFormCheckbox
} from 'bootstrap-vue'

export default {
  components: {
    vSelect,
    Datepicker,
    BFormCheckbox
  },
  props: {
    services: {
      type: Object,
      default: null
    },
    emailTypeList: {
      type: Object,
      default: () => []
    }
  },
  data: () => ({
    format: 'dd/MM/yyyy',
    ptBR,
    id: null,
    parentEntity: null,
    emailTypes: [],
    accountType: null,
    branchNumber: null,
    accountNumber: null,
    issuedAt: null,
    head: false,
    financialInstitutionList: [],
    bankDetailList: [],
    financialInstitution: null,
    editMode: false
  }),
  computed: {
    accountTypeList() {
      return Constants.ACCOUNT_TYPES
    },
    validateForm() {
      return (
        this.accountType !== null &&
        !this.isEmpty(this.financialInstitution) &&
        !this.isEmpty(this.branchNumber) &&
        !this.isEmpty(this.accountNumber)
      )
    }
  },
  watch: {},
  methods: {
    save() {
      this.clearErrors(this.$validator)
      this.$vs.loading()

      const params = {
        people_id: this.parentEntity.people.id,
        financial_institution_id: this.financialInstitution.id,
        account_type: this.accountType.code,
        branch_number: this.branchNumber
          ? this.clearDashDots(this.branchNumber)
          : '',
        account_number: this.accountNumber
          ? this.clearDashDots(this.accountNumber)
          : '',
        issued_at: this.issuedAt,
        head: !!this.head
      }

      if (this.editMode) {
        params['id'] = this.id
      }

      this.services.bankDetailService.createOrUpdate(params).then(
        data => {
          this.$vs.loading.close()
          this.bankDetailList = data.banks
          this.editMode = false
          this.clearFields()
          this.notifySuccess(this.$vs)
        },
        error => {
          this.$vs.loading.close()
          this.showErrors(this.$validator, error)
        }
      )
    },
    destroy(bankDetail) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirmação',
        acceptText: 'Sim',
        cancelText: 'Não',
        text: 'Tem certeza que deseja excluir este registro?',
        accept: () => {
          this.acceptDestroy(bankDetail)
        }
      })
    },
    acceptDestroy(bankDetail) {
      this.$vs.loading()
      this.services.bankDetailService
        .destroy({
          id: bankDetail.id
        })
        .then(
          data => {
            this.$vs.loading.close()
            this.bankDetailList = this.bankDetailList.filter(element => {
              return element.id !== bankDetail.id
            })
            this.notifySuccess(this.$vs)
          },
          error => {
            this.$vs.loading.close()
            this.showErrors(this.$validator, error)
          }
        )
    },
    edit(bankDetail) {
      this.id = bankDetail.id
      this.editMode = true
      this.accountType = this.accountTypeList.filter(element => {
        return element.code === bankDetail.account_type
      })[0]
      this.financialInstitution = bankDetail.financial_institution
      this.branchNumber = bankDetail.branch_number
      this.accountNumber = bankDetail.account_number
      this.issuedAt = bankDetail.issued_at
      this.head = bankDetail.pivot.head
    },
    cancelEdit() {
      this.editMode = false
      this.clearFields()
    },
    clearFields() {
      this.accountType = null
      this.financialInstitution = null
      this.branchNumber = null
      this.accountNumber = null
      this.issuedAt = null
      this.head = null
    }
  },
  beforeMount() {
    this.$vs.loading()
    this.services.financialInstitutionService.all().then(
      data => {
        this.$vs.loading.close()
        this.financialInstitutionList = data
        this.financialInstitutionList.forEach(element => {
          element.name = `${element.code} - ${element.name}`
        })
      },
      error => {
        this.$vs.loading.close()
      }
    )
  },
  mounted() {
    this.$root.$on('naturalEntityUpdated', () => {
      this.parentEntity = this.$store.getters['naturalEntity/naturalEntity']
      this.bankDetailList = Array.from(this.parentEntity.people.banks)
    })

    this.$root.$on('legalEntityUpdated', () => {
      this.parentEntity = this.$store.getters['legalEntity/legalEntity']
      this.bankDetailList = Array.from(this.parentEntity.people.banks)
    })
  }
}
</script>
